module.exports = __webpack_public_path__ + "static/kodan-11078cc71c6f8a582a318577a79387ef.svg";